export default __webpack_public_path__ + "static/media/tick.0c9b96aa.svg";